import React from 'react';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';

const StyledCheckboxIcon = styled('span')(({ theme, small }) => ({
  backgroundColor: 'white',
  borderRadius: 2,
  border: '2px solid ' + theme.colors.primary[400],
  width: small ? '15px !important' : 20,
  height: small ? '15px !important' : 20,
  'input:hover ~ &': {
    backgroundColor: '#ebf1f5',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background: 'rgba(206,217,224,.5)',
  },
}));

const StyledCheckboxCheckedIcon = styled(StyledCheckboxIcon)(({ theme, small }) => ({
  '&:before': {
    display: 'block',
    background: theme.colors.primary[400],
    width: small ? '5px !important' : 10,
    height: small ? '5px !important' : 10,
    marginTop: 3,
    marginLeft: 3,
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: theme.colors.primary[400],
  },
}));

const StyledCheckbox = styled(Checkbox)(({ theme, small }) => ({
  ...(small && {
    padding: 0
  })
}));

const CheckboxUI = (props) => {
    let { small = false, ...other } = props;

    return (
        <StyledCheckbox
            small={small ? 1 : 0}
            disableRipple
            color="default"
            checkedIcon={<StyledCheckboxCheckedIcon small={small ? 1 : 0} />}
            icon={<StyledCheckboxIcon small={small ? 1 : 0} />}
            {...other}
        />
    );
}

export default CheckboxUI;